// @ts-nocheck

import { ResizeSensor } from '@blueprintjs/core';
import { createChart, ColorType, PriceScaleMode } from 'lightweight-charts';
import React, { useEffect, useRef, useState } from 'react';
import { priceSentimentLineChartData } from '../Services/apiRoutes';
import { CircularProgress, Typography } from '@mui/material';

// export default function ResearchCard({
//     author, url, title, coinsUsed, icons, date
// }) {}; 


export function PriceSentimentLineChart({ coin }) {
  const [priceSentimentLineData, setPriceSentimentLine] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [coorelation, setcoorelation] = useState();
  useEffect(() => {
    getPriceSentimentLineChart();
  }, []);
  const getPriceSentimentLineChart = async () => {
    try {
      const initialData = [];

      const { data } = await priceSentimentLineChartData(coin);
      setcoorelation(data.coorelation.toFixed(2));
      for (let i = 0; i < data.Date.length; i++) {
        const item = {
          time: data.Date[i],
          value: data.Price[i],
          sentiment: data.Sentiment[i],
        };
        initialData.push(item);
      }
      let sortedData = initialData.sort((a, b) => {
        return new Date(a.time).getTime() - new Date(b.time).getTime();
      });
      setPriceSentimentLine(sortedData);
      setIsLoading(false);
      console.log('sortedData', sortedData);
    } catch (error) {
      // setIsLoading(false);
    }
  };

  return (
    <div style={{ height: "100%", display: "flex" }}>
      {isLoading ? (
        <CircularProgress style={{
          margin: "auto",
        }}></CircularProgress>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography sx={{  fontSize: "14px" ,paddingBottom:"5px"}}>{coin} / USDT Correlation : {coorelation}</Typography>
          <div style={{ display: "flex", justifyContent:"space-between", width: "100%",paddingBottom: "5px" }}>
          <Typography sx={{  fontSize: "14px", color:"#E66262"  }}>Sentiment</Typography>
          <Typography sx={{  fontSize: "14px",color:"#4F9F65",marginRight:"15px"}}>Price</Typography>
          </div>
          <ChartComponent data={priceSentimentLineData}></ChartComponent>
        </div>
      )}
    </div>
  );
}





export function ChartComponent({ data }) {
  const [height, setHeight] = useState(300);
  const chartContainerRef = useRef();

  // const  backgroundColor = '#2B3657';
  // const color = '#4F9F65';
  // const textColor = 'white';

  useEffect(() => {

    // Find min and max sentiment values
    let sentimentMin = Math.min(...data.map(item => item.sentiment));
    let sentimentMax = Math.max(...data.map(item => item.sentiment));

    const handleResize = () => {
      chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    };

    const chart = createChart(chartContainerRef.current, {
      layout: {
        // background: { type: ColorType.Solid, color: backgroundColor },
        // textColor,
        legend: {
          visible: true,
          position: 'top',
          fontSize: 12,
          // fontColor: textColor,
        },
      },
      grid: {
        vertLines: false,
        horzLines: false,
      },
      width: chartContainerRef.current.clientWidth,
      // height: 330,
      // ...
      rightPriceScale: {
        visible: true,
        scaleMargins: {
          top: 0.3,
          bottom: 0.25,
        },
      },

      leftPriceScale: {
        visible: true,
        scaleMargins: {
          top: 0.1,
          bottom: 0,
        },
        mode: PriceScaleMode.Normal,
      },
      // ...
    });
    const valueSeries = chart.addLineSeries({
      color:'#4F9F65', // Color for value line series
      lineWidth: 5,
      priceScaleId: 'right', // Assigning the right y-axis
    });
    valueSeries.setData(data.map(item => ({ time: item.time, value: item.value })));

    const sentimentSeries = chart.addLineSeries({
      color: '#E66262', // Color for sentiment line series
      lineWidth: 5,
      priceScaleId: 'left', // Assigning the left y-axis
    });
    // Scale sentiment values to percentages
    sentimentSeries.setData(
      data.map(item => ({
        time: item.time,
        value: ((item.sentiment - sentimentMin) / (sentimentMax - sentimentMin)) * 100,
      })),
    );
    // Manually set the scale of the sentimentSeries to range from 0 to 100
    chart.priceScale('left').applyOptions({
      autoScale: false,
      minValue: 0,
      maxValue: 100,
    });

    // Custom axis labels

    //   const rightAxisLabel = document.createElement('div');
    //   rightAxisLabel.innerText = 'Price';
    //   rightAxisLabel.style.position = 'absolute';
    //   rightAxisLabel.style.color = 'white';
    //   // rightAxisLabel.style.top = '4px';
    //   rightAxisLabel.style.right = '5px';
    //   rightAxisLabel.style.zIndex = '1000';
    //   chartContainerRef.current.appendChild(rightAxisLabel);

    //   const leftAxisLabel = document.createElement('div');
    //   leftAxisLabel.innerText = 'Sentiment';
    //   leftAxisLabel.style.position = 'absolute';
    //   leftAxisLabel.style.color = 'white';
    //   // leftAxisLabel.style.top = '5px';
    //   leftAxisLabel.style.left = '5px';
    //   leftAxisLabel.style.zIndex = '1000';
    //   chartContainerRef.current.appendChild(leftAxisLabel);


    chart.timeScale().fitContent();

    // const newSeries = chart.addLineSeries({ color, lineWidth: 5 });
    // newSeries.setData(data);
    const toolTipWidth = 80;
    const toolTipHeight = 80;
    const toolTipMargin = 15;

    // Create and style the tooltip html element
    const toolTip = document.createElement('div');
    toolTip.style = `width: ${toolTipWidth}; height: 80px; position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
    toolTip.style.background = 'white';
    toolTip.style.color = 'black';
    toolTip.style.borderColor = 'rgba( 38, 166, 154, 1)';

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);

      chart.remove();
    };
  }, [data]);

  return (
    <ResizeSensor onResize={entries => setHeight(entries[0].contentRect.height)}>
      <div
        style={{
          position: 'relative',
          height: '100%',
          width: '100%',
        }}
        ref={chartContainerRef}
      />
    </ResizeSensor>
  );
};